import {BaseCaller} from './api';

export default class BranchApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public add(data: any) {
        return this.caller.post("branch", data);
    }

    public update(id: number, data: any) {
        return this.caller.put('branch/' + id.toString(), data);
    }

    public listAllBranchesAdmin(){
        return this.caller.get('branch/allAdminBranches');
    } 

    public delete(id: number) {
        return this.caller.delete('branch/' + id.toString());
    }
}



// WEBPACK FOOTER //
// ./src/api/branch-api.ts